import React from 'react';

const CtaBoxSubtitle: React.FC<React.PropsWithChildren> = (props) => {
    return <div className="cta-box__subtitle">{props.children}</div>;
};

export default CtaBoxSubtitle;
